export default function (days = 30, seconds = 10, cookieName = '') {
  return {
    open: false,
    days,
    seconds,
    popUpDiscarded: false,
    cookieName,

    init() {
      // Check if the cookie exists
      this.popUpDiscarded = this.getCookie(this.cookieName) === 'true'
      
      if (!this.popUpDiscarded) {
        setTimeout(() => { this.open = true; }, this.seconds * 1000)
      }
    },

    discard() {
      this.popUpDiscarded = true
      this.setCookie(this.cookieName, 'true', this.days)
      this.open = false
    },

    // Helper function to set a cookie
    setCookie(name, value, days) {
      let expires = ''
      if (days) {
        const date = new Date()
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
        expires = '; expires=' + date.toUTCString()
      }
      document.cookie = name + '=' + value + expires + '; path=/'
    },

    // Helper function to get a cookie
    getCookie(name) {
      const nameEQ = name + '='
      const ca = document.cookie.split(';')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
      }
      return null
    }
  }
}
